import * as Sentry from '@sentry/react';

/**
 * Initialise Sentry error monitoring.
 *
 * DSN / environment come from build-time env vars so non-prod builds can be
 * pointed elsewhere or disabled by leaving REACT_APP_SENTRY_DSN empty.
 */
export const initSentry = (): void => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    release: process.env.REACT_APP_VERSION,
  });
};

/** True when REACT_APP_SENTRY_TEST_BUTTON=true and Sentry is enabled. */
export const isSentryTestButtonEnabled = (): boolean => {
  if (!process.env.REACT_APP_SENTRY_DSN) {
    return false;
  }

  return process.env.REACT_APP_SENTRY_TEST_BUTTON === 'true';
};
